<template>
  <div class="page-careers">
    <vue-headful
      title="Itchyfeet - Careers"
      description="Itchyfeet Careers"
    />
    <section class="careers-section-1 container-fluid">
      <div class="container h-100">
        <div class="d-flex text-center h-100 justify-content-center">
          <div class="my-auto w-50 text-success">
            <h1>Careers.</h1>
          </div>
        </div>
      </div>
    </section>

    <section class="careers-section-2 container-fluid py-5">
      <div class="container h-100">
        <div class="row mt-4" v-for="careerPost in posts" v-bind:key="careerPost.name">
          <div class="col-md-12">
            <div class="card">
              <div class="row no-gutters">
                <div class="col-8">
                  <img v-if="careerPost.image" class="img-fluid" v-bind:src="careerPost.image">
                </div>
                <div class="col">
                  <div class="card-block p-2 h-100">
                    <h4 class="card-title mt-2 mb-1">{{careerPost.name}}</h4>
                    <p class="mb-2">{{careerPost.contractType}}, {{careerPost.location}}</p>
                    <p>{{careerPost.description}}</p>
                    <a class="text-success pb-2" v-bind:href="careerPost.link" target="_blank">Read More →</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ul class="pagination justify-content-center mb-4">
          <li class="page-item">
            <a class="btn btn-lg page-link mt-5" href="https://thehub.dk/jobs/company/itchyfeet" target="_blank">View All</a>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
import data from '../../../data/careers.json'

export default {
  name: 'Careers',
  computed: {
    posts: function () {
      return data
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../styles/app";
  @import "../../styles/careers";
</style>



// WEBPACK FOOTER //
// src/components/Careers/Careers.vue